import { EstateResultRule } from 'queries';

import Modal from 'common/modal';

import EstateResultRuleActionForm from './estate-result-rule-action-form';

type Props = {
  currentEstateResultRule: EstateResultRule;
  setCurrentEstateResultRule: (value: EstateResultRule | undefined) => void;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function UpdateEstateResultRuleActionModal({
  currentEstateResultRule,
  setCurrentEstateResultRule,
  setShowModal,
  showModal,
}: Props) {
  const onExitClick = () => {
    setShowModal(false);
    setCurrentEstateResultRule(undefined);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <EstateResultRuleActionForm
          estateResultRuleAction={currentEstateResultRule.action!}
          onExitClick={onExitClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
